import React, { useCallback } from 'react';
import Coordinate from '../../../../../common/coordinate';
import { useEvent } from '../../../../contexts/event-bus';
import WorkspaceItemContext from '../../../../contexts/workspace/workspace-item-context';

export function FlightAlerts() {
    const context = React.useContext(WorkspaceItemContext);
    useEvent(
        'alert-zoom-to-aircraft',
        useCallback(
            (e) => {
                const flight = context.flightLayerFacade.flights.getFlight(e.id);
                if (!flight) {
                    return;
                }

                context.map?.goToFlight(new Coordinate(flight.currentPosition[1], flight.currentPosition[0]), 12);
            },
            [context]
        )
    );
    return <></>;
}
